import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/axios/requestInfo";
import { api } from "../../../resources/api";

import { IPayAll, IPayToken, IResponseData } from "./types";

export const fetchGetWebPayToken = createAsyncThunk<IResponseData, IPayAll>(
  "getToken/fetchGetWebPayToken",
  async (data) => {
    try {
      const response = await axiosInstance.post(
        api.payment.CREATE_PAYMENT_LINKED_CARD,
        data
      );
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }
);
